import { render } from "./FriendRequest.vue?vue&type=template&id=50261eb2&scoped=true"
import script from "./FriendRequest.vue?vue&type=script&lang=js"
export * from "./FriendRequest.vue?vue&type=script&lang=js"

import "./FriendRequest.vue?vue&type=style&index=0&id=50261eb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50261eb2"]])

export default __exports__